<template>
  <header
    :class="[
      $style.root,
      {
        [$style.sticky]: sticky,
        [$style.menuOpen]: showMenu,
        [$style.painted]: isJobPage,
      }
    ]"
  >
    <div :class="$style.container">
      <div :class="$style.mobileHeader">
        <BaseBurger
          :class="$style.burger"
          :is-active="showMenu"
          @click="toggleMenu"
        />

        <router-link
          :class="$style.logo"
          :to="{name: 'HOME'}"
          @click.native="hideMenu"
        >
          <app-image
            :x1="isCampPage ? '/static/logo_dark.svg' : '/static/logo.svg'"
            :class="$style.logoDesktop"
            alt="Логотип"/>

          <app-image
            :class="$style.logoMobile"
            x1="/static/logo_mobile.svg"
            alt="Логотип"/>
        </router-link>
      </div>
      <nav :class="[$style.navigation, {[$style.showed]: showMenu}]">
        <ul>
          <li :class="[$style.menuItem, $style.mobileVisible]" >
            <router-link
              :class="$style.menuLink"
              to="/"
              @click.native="hideMenu"
            >Главная</router-link>
          </li>
          <li
            v-for="(item, index) in menu"
            :key="index"
            :class="$style.menuItem"
          >
            <router-link
              :to="item.path"
              :class="$style.menuLink"
              :active-class="$style.menuLinkActive"
              @click.native="hideMenu"
            >{{ item.name }}</router-link>
          </li>
          <li :class="[$style.menuItem]" >
            <a
              :class="$style.menuLink"
              href="https://blog.interesnee.ru"
              target="_blank"
            >Блог</a>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import BaseBurger from 'components/BaseBurger';
import { JOB, CAMP } from 'router/index';

export default {
  name: 'TheHeader',
  components: {
    BaseBurger,
  },
  props: {
    kind: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      sticky: false,
      scrolled: false,
      showMenu: false,
    };
  },
  computed: {
    menu() {
      const routes = [...this.$router.options.routes];

      const routesInMenu = routes.filter(
        route => route.meta && route.meta.menuName,
      );

      const menuItems = routesInMenu.map(item => ({
        name: item.meta.menuName,
        path: item.path,
      }));

      return menuItems;
    },

    isJobPage() {
      return this.$route.name === JOB;
    },
    isCampPage() {
      return this.$route.name === CAMP;
    },
  },
  watch: {
    showMenu() {
      // Emit this information to the parents component
      this.$emit('child-checkbox', this.showMenu);
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (!this.sticky) {
        this.scrolled = window.scrollY > 160;
      }
      if (this.scrolled) {
        this.sticky = true;
      }
      if (this.sticky && window.scrollY === 0) {
        this.scrolled = false;
        this.sticky = false;
      }
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    hideMenu() {
      this.showMenu = false;
    },
  },
};
</script>

<style lang="scss" module>
@import '~styles/variables';
@import '~styles/helpers';
@import '~styles/mixins';

$header-color: transparent;
$header-color-sticky: $red;

.root {
  width: 100%;
  background-color: $header-color;
  height: $header-height;
  position: absolute;
  z-index: $zidx-super;
  left: 0;
  top: 0;
  transition: background-color $transitions-delay $transitions-type,
    box-shadow $transitions-delay $transitions-type;

  @include media('<desktop') {
    height: $header-height-mobile;
  }
}

@keyframes slideTop {
  from {
    transform: translateY(-100%);
  }

  to {
    transform: translateY(0);
  }
}

.sticky {
  animation-name: slideTop;
  animation-duration: $transitions-delay;
  position: fixed;
  background-color: $header-color-sticky;
  box-shadow: 0 5px 10px rgba(47, 25, 25, 0.3);
}

.mobileHeader {
  height: $header-height;
  display: flex;
  align-items: center;

  @include media('<desktop') {
    height: $header-height-mobile;
    width: 100%;
    position: relative;
    z-index: $zidx-over;
    padding: 0 $grid-gutter-mobile;
  }
}

.sticky .mobileHeader {
  @include media('<desktop') {
    background-color: $header-color-sticky;
  }
}

.menuOpen {
  @include media('<desktop') {
    background-color: $header-color-sticky;
    height: auto;
    transition: none;
  }
}

.container {
  @extend %container;

  height: 100%;
  padding: 0 50px;
  display: flex;
  align-items: center;

  @include media('<desktop') {
    flex-wrap: wrap;
    padding: 0;
  }
}

.burger {
  display: none;

  @include media('<desktop') {
    display: block;
  }
}

.logoDesktop {
  display: block;

  @include media('<desktop') {
    display: none;
  }
}

.logo {
  @include media('<desktop') {
    height: $header-height-mobile;
    flex: 1;
    display: flex;
    justify-content: center;
    padding-right: $hamburger-total-width;
    padding-bottom: 3px;
  }
}

.logoMobile {
  display: none;
  width: 37px;

  @include media('<desktop') {
    display: block;
  }
}

.navigation {
  flex: 1;

  @include media('>=desktop') {
    display: block;
  }

  @include media('<desktop') {
    flex-basis: 100%;
    display: none;
    background-color: $red;
  }

  &.showed {
    display: block;
  }
}

.menuOpen .navigation {
  @include media('<desktop') {
    height: calc(100vh - #{$header-height-mobile});
    align-items: center;
    display: flex;
    position: fixed;
    left: 0;
    top: 40px;
    width: 100%;
    z-index: $zidx-main;
  }
}

.navigation ul {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0;
  list-style-type: none;

  @include media('<desktop') {
    flex-wrap: wrap;
    padding: 30px 30px #{30px + $header-height-mobile};
  }
}

%menuLinkActive {
  color: $white;
  border-color: $red-light;
  border-radius: 50px;
}

.menuLinkActive {
  @extend %menuLinkActive;
}

.menuItem {
  margin-left: 30px;

  @include media('<desktop') {
    flex-basis: 100%;
    margin-left: 0;
    border-bottom: 1px solid $red-2;
  }
}

.mobileVisible {
  @include media('>=desktop') {
    display: none;
  }
}

.menuLink {
  display: block;
  color: $white;
  text-decoration: none;
  border: 2px solid $transparent;
  padding: 5px 10px;

  @include media('<desktop') {
    font-size: 22px;
    padding: 13px 10px;
    border-width: 0 0 2px;
    border-radius: 0;
  }

  @include on-event {
    @extend %menuLinkActive;
  }
}

@include media('<desktop') {
  .menuLink {
    @include on-event {
      border-radius: 0;
    }
  }
}

.menuLink.menuLinkActive {
  @extend %menuLinkActive;

  @include media('<desktop') {
    border-radius: 0;
  }
}

.root.dump .menuLink {
  @include on-event {
    border-color: $red;
  }
}

.root.dump .menuLinkActive {
  border-color: $red;
}

.root.dump.sticky {
  background-color: $red-light;
}

.painted {
  background-color: $red;
}
</style>



// WEBPACK FOOTER //
// src/components/TheHeader.vue